module.exports = __webpack_public_path__ + "img/extrovertida.2f8d235d.png";